import React from 'react'
import _ from 'underscore'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import Tooltip from 'components/Tooltip'

import { color } from 'styles/colors'

interface PiiFlag {
  customerId: string;
  variant: 'new' | 'updated' | 'duplicate' | null // TODO: null should not be a valid variant DWA-3066
  duplicateNames?: string;
}

const PiiFlag = ({ customerId, variant, duplicateNames = '' }: PiiFlag) => {
  const flagTooltip = 'Use the Edit Customer screen to remove this label. Click this button to go straight there.'

  const variantType = _.find([
    { name: 'new', displayName: 'NEW', tooltip: flagTooltip },
    { name: 'updated', displayName: 'UPDATED', tooltip: flagTooltip },
    { name: 'duplicate', displayName: 'DUPLICATE', tooltip: `This might be a duplicate account. Also see ${duplicateNames}` }
  ], (type) => type.name === variant)

  return (
    <div>
      {variantType &&
        <Tooltip title={variantType.tooltip} placement="top">
          <NavLink to={`/customers/${customerId}/edit`}>
            <S.PiiFlag>{variantType.displayName}</S.PiiFlag>
          </NavLink>
        </Tooltip>
      }
    </div>
  )
}

export default PiiFlag

const S = {
  PiiFlag: styled.div`
    margin: 3px 5px 3px 0px;
    display: inline-block;
    width: 80px;
    font-weight: bold;
    border-radius: 5px;
    background: ${color('tagBackground')};
    text-align: center;
  `
}
